import { STATUS } from "#vacancy/constants"
import { Box, Typography } from "@mui/material"
import VacancyDialogStatus from "./VacancyDialogStatus"
import InputSelect from "#core/components/input/select/InputSelect"
import { useApi } from "#hooks/useApi"
import { colaboradorRhGet } from "modules/colaborador/services/api"
import { useState } from "react"
import { toast } from "react-toastify"

export default function VacancyDialogPublishingVacancy({ open, setOpen, profileData }) {
	const { id: vacanteId, perfil_puesto_name } = profileData || {}
	const { data } = useApi(colaboradorRhGet, { autoFetch: open })
	const [reclutador, setReclutador] = useState(null)

	return (
		<VacancyDialogStatus
			{...{
				open,
				setOpen,
				vacanteId,
				status: STATUS.PUBLISHING,
				reclutador,
				title: "Publicar Vacante",
				validation: (data) => {
					if (!data.reclutador) {
						toast.error("Seleccione un reclutador")
						return false
					}
					return true
				},
			}}
		>
			<Box display="flex" gap={2} flexDirection="column">
				<Typography variant="body1" sx={{ textAlign: "center" }}>
					¿Esta seguro de publicar la vacante <strong>{perfil_puesto_name}</strong>?
				</Typography>
				<Typography variant="body2" sx={{ textAlign: "center" }}>
					Esta acción no se puede deshacer.
				</Typography>
				<InputSelect
					label="Reclutador"
					options={data?.data}
					optionsId="id"
					optionsLabel="full_name"
					value={reclutador}
					setValue={setReclutador}
				/>
			</Box>
		</VacancyDialogStatus>
	)
}
